import React from 'react';
import Header from '../components/header'
import Footer from '../components/footer';
import './landingPage.css'
import { VerticalSeparator, LineSeparator } from '../components/separators';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

import Sfondo1_2 from '../photos/Sfondi Mare/Sfondo mare 1_2.jpg';

import FotoCard1 from '../photos/Case/Facciata/giardino 1.jpg'
import FotoCard2 from '../photos/Case/Facciata/esterno primo piano_sfondo_orizzontale.jpg'
import CardHouse from '../components/cardHouses';
import GalleryComponent from '../components/galleryWrapper.js';
import DataLandingPage from '../galleries/data/dataLandingPage.ts';

const LandingPage = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />

      <Container fluid style={{ padding: '0', position: 'relative' }}>

        <Card style={{ position: 'relative' }}>
          <Card.Img src={Sfondo1_2} alt='' style={{ borderRadius: '0' }} />
          <div className="
            position-absolute
            end-0
            text-light"
            style={{ zIndex: '1', backgroundColor: 'rgba(0, 0, 0, 0.2)', borderRadius: '0', marginRight: '5vw', marginTop: '5vw' }}>
            <h1 className="text-sfondo-h-landingpage-class" style={{ textAlign: 'center', marginLeft: '20px', marginRight: '20px', marginTop: '10px', marginBottom: '12px' }}>
              {selectedLanguage === 'ita' ? "La Casa Santa Barbara" : "The Casa Santa Barbara"}<br />
              {selectedLanguage === 'ita' ? "ti da il benvenuto" : " welcomes you"}<br />
              {selectedLanguage === 'ita' ? " a Marina di Ragusa" : "In Marina di Ragusa"}
            </h1>
            <p className="text-sfondo-p-landingpage-class" style={{ textAlign: 'center' }}>
              {selectedLanguage === 'ita' ? "- Affitti case vacanza -" : "- Vacation home rentals -"}
            </p>
          </div>
        </Card>

        <LineSeparator></LineSeparator>

        <div style={{ textAlign: 'center', backgroundColor: '#e0e0e0' }}>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <h1 className='text-h-landingpage-class' style={{ marginRight: '10px', marginLeft: '10px' }}>{selectedLanguage === 'ita' ? "Due appartamenti appena ristrutturati!" : "Two newly renovated apartments!"}</h1>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <p className='text-p-landingpage-class' style={{ margin: 'auto', maxWidth: '85%' }}>
            {selectedLanguage === 'ita' ? "Gli appartamenti situati a Marina di Ragusa si trovano a pochi passi dal mare e sono ben posizionati in modo da poter raggiungere con facilità la spiaggia e il centro, spostandosi anche a piedi o in bici lungo la pista ciclabile del lungomare Bisani. Ideali per trascorrere una rilassante vacanza al mare in famiglia, in coppia o in gruppo." : "The apartments located in Marina di Ragusa are just a few steps away from the sea and are well positioned for easy access to the beach and the town center, allowing guests to move around on foot or by bike along the Bisani seafront cycle path. Ideal for spending a relaxing seaside vacation with family, as a couple, or in a group."}
          </p>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
        </div>

        <LineSeparator></LineSeparator>

        <div style={{ textAlign: 'center', margin: 'auto', maxWidth: '85%' }}>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <div>
            <h1 className='text-h-landingpage-class'>
              {selectedLanguage === 'ita' ? "Le nostre case vacanza a Marina di Ragusa" : "Our holiday homes in Marina di Ragusa"}
            </h1>
          </div>
          <VerticalSeparator height={"1vw"}></VerticalSeparator>
          <div className="row">
            <div className="col-md-6 mb-2">
              <Link to="/house1" className='link-card'>
                <CardHouse img={FotoCard1} text={selectedLanguage === 'ita' ? "Piano Terra" : "Ground Floor"} />
              </Link>
            </div>
            <div className="col-md-6">
              <Link to="/house2" className='link-card'>
                <CardHouse img={FotoCard2} text={selectedLanguage === 'ita' ? "Primo Piano" : "First Floor"} />
              </Link>
            </div>
          </div>
        </div>

        <LineSeparator></LineSeparator>

        <div style={{ backgroundColor: '#e0e0e0', alignItems: 'center', textAlign: 'center' }}>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <h1 className='text-h-landingpage-class'>{selectedLanguage === 'ita' ? "Informazioni" : "About us"}</h1>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <p className='text-p-landingpage-class' style={{ margin: 'auto', maxWidth: '85%' }}>
            {selectedLanguage === 'ita' ? "Il litorale ibleo è una tra le coste più rinomate e suggestive della Sicilia. Si alternano ampie spiagge di sabbia dorata finissima con bellissime scogliere. Il mare è stato più volte premiato con l’ambita bandiera blu. Il clima mite per gran parte dell’anno permette soggiorni piacevoli e rilassanti anche in mesi di bassa stagione." : "The Iblean coastline is one of the most renowned and picturesque coastlines in Sicily. It alternates between wide beaches of fine golden sand and beautiful cliffs. The sea has been awarded the coveted Blue Flag multiple times. The mild climate for much of the year allows for pleasant and relaxing stays even in the low season months."}
            <br />
            <br />
            {selectedLanguage === 'ita' ? "Le spiagge libere di fine sabbia dorata di Marina di Ragusa sono perfette per grandi e piccini mentre i diversi stabilimenti balneari danno la possibilità di noleggiare sdraio e ombrelloni permettendo così di trascorrere intere giornate al mare in tutta comodità." : "The free beaches with fine golden sand in Marina di Ragusa are perfect for both adults and children, while the various bathing establishments offer the opportunity to rent sun loungers and umbrellas, allowing you to spend entire days at the beach in complete comfort."}
            <br />
            <br />
            {selectedLanguage === 'ita' ? "Durante la stagione estiva il borgo marino si anima di turisti e la piazzetta centrale si riempie di vita dalla mattina fino a tarda notte con musica ed eventi. Il porto turistico di Marina di Ragusa offre diverse attività e sport acquatici. In primavera e autunno inoltrato, la serenità e il clima mite del luogo possono offrire agli amanti della tranquillità un soggiorno in totale relax, lontano dal caos cittadino e dalla routine quotidiana." : "During the summer season, the seaside village comes alive with tourists, and the central square fills with life from morning until late at night with music and events. The marina of Marina di Ragusa offers various water activities and sports. In late spring and autumn, the serenity and mild climate of the area can offer tranquility lovers a stay in total relaxation, away from the city chaos and daily routine."}
          </p>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
        </div>

        <LineSeparator></LineSeparator>

        <Card style={{ backgroundColor: '#e0e0e0', alignItems: 'center', textAlign: 'center', maxWidth: '85%', margin: 'auto' }}>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <h1 className='text-h-landingpage-class'>{selectedLanguage === 'ita' ? "Siamo qui!" : "We are here!"}</h1>
          <VerticalSeparator height={"2vw"}></VerticalSeparator>
          <iframe
            title="Posizione"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.5374694102725!2d14.530681275349131!3d36.78166196874515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1311b8e2f9d82b45%3A0xb8ae07113bc5cc92!2sVia%20Milano%2C%208%2C%2097100%20Marina%20di%20Ragusa%20RG!5e0!3m2!1sit!2sit!4v1711903512166!5m2!1sit!2sit"
            width="90%"
            height="400vw"
            style={{ marginBottom: "20px", marginRight: "20px", marginLeft: "20px", borderRadius: '10px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </Card>

        <LineSeparator></LineSeparator>

        <GalleryComponent text={selectedLanguage === 'ita' ? "Il nostro mare e le nostre spiagge" : "Our sea and our beaches"} DataHousePage1={DataLandingPage}></GalleryComponent>

      </Container>
      <Footer />
    </>
  );
}



export default LandingPage;
